import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateMappingTemplate } from "../../models/mappingtemplates/CreateMappingTemplate";
import { CreateMappingTemplateMapping } from "../../models/mappingtemplates/CreateMappingTemplateMapping";
import { CreateMappingTemplateMappingsBulk } from "../../models/mappingtemplates/CreateMappingTemplateMappingsBulk";
import { FieldMappingTemplate } from "../../models/mappingtemplates/FieldMappingsTemplate";
import { UpdateMappingTemplate } from "../../models/mappingtemplates/UpdateMappingTemplate";
import { UpdateMappingTemplateMapping } from "../../models/mappingtemplates/UpdateMappingTemplateMapping";

const RESOURCE_NAME = "mappingtemplates";
const MAPPINGS__RESOURCE_NAME = "fieldmappingtemplates";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const create = (model: CreateMappingTemplate) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (model: UpdateMappingTemplate) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.id}`, requestConfig());
};

const remove = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const getAllMappings = (mappingTemplateId: number) => {
  const http = getAxiosInstance();
  return http.get<FieldMappingTemplate[]>(`${MAPPINGS__RESOURCE_NAME}/${mappingTemplateId}`, requestConfig());
};

const createMapping = (model: CreateMappingTemplateMapping) => {
  const http = getAxiosInstance();
  return http.post(`${MAPPINGS__RESOURCE_NAME}`, model, requestConfig());
};

const createMappingsBulk = (model: CreateMappingTemplateMappingsBulk) => {
  const http = getAxiosInstance();
  return http.post(`${MAPPINGS__RESOURCE_NAME}/CreateMultiple`, model, requestConfig());
};

const updateMapping = (model: UpdateMappingTemplateMapping) => {
  const http = getAxiosInstance();
  return http.put(`${MAPPINGS__RESOURCE_NAME}/${model.id}`, requestConfig());
};

const removeAllMappings = (mappingTemplateId: number) => {
  const http = getAxiosInstance();
  return http.delete(`${MAPPINGS__RESOURCE_NAME}/DeleteAll/${mappingTemplateId}`, requestConfig());
};

const MappingTemplateService = {
  getAll,
  create,
  update,
  remove,
  getAllMappings,
  createMapping,
  createMappingsBulk,
  updateMapping,
  // removeMapping,
  removeAllMappings
};
export default MappingTemplateService;
